export const SearchFilterRecipes = {
  bindings: {
    filters: '<',
    onClick: '&',
  },

  template: `
    <div class="search-filter-recipes">
      <search-filter
        title="Protein"
        type="radio"
        list="$ctrl.filters['Protein']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Time"
        type="radio"
        list="$ctrl.filters['Time']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Meal Type"
        type="checkbox"
        list="$ctrl.filters['Meal Type']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Meal"
        type="radio"
        list="$ctrl.filters['Meal']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Serves"
        type="radio"
        list="$ctrl.filters['Serves']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'serves'})">
      </search-filter>
      <search-filter
        title="Dietary Preferences"
        type="radio"
        list="$ctrl.filters['Dietary Preferences']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Nutrition Preferences"
        type="radio"
        list="$ctrl.filters['Nutrition Values']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
      <search-filter
        title="Other"
        type="radio"
        list="$ctrl.filters['Other']"
        on-click="$ctrl.onClick({ item: item, type: type, list: list, key: 'filters'})">
      </search-filter>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilterRecipes.js